import React, { useEffect, useMemo, useRef, useState } from "react"
import { Form, Toast, } from 'react-bootstrap'
import { useHistory } from "react-router"
import { useRecoilValue } from "recoil"
import { exportAbnormalPriceProducts, getAbnormalPriceProduct, getAbnormalPriceProductCount } from "../../../api"
import { accountDataState } from "../../../recoil/account"
import { formatPrice } from "../../../utils"
import { useAsync } from "../../../utils/hooks"
import Loading from "../../shared/Loading"
import ReactPaginate from 'react-paginate';
import MyToast from './MyToast';

type ITimes = '2' | '5' | '10' | '15' | '20'
type IArea = 'mien_bac' | 'mien_nam' | 'mien_trung' | ''

interface IState {
    offset: number,
    limit: number,
    listProduct: Array<any>,
    times: ITimes,
    area: IArea,
    total?: number,
    exporting: boolean,
}

const initState: IState = {
    offset: 0,
    limit: 20,
    listProduct: [],
    area: '',
    times: '10',
    total: 0,
    exporting: false,
}





const AbnormalPriceProduct = React.memo(() => {
    const history = useHistory()
    const getAbnormalPriceProductAsync = useAsync(getAbnormalPriceProduct)
    const getAbnormalPriceProductCountAsync = useAsync(getAbnormalPriceProductCount)
    const exportAbnormalPriceProductsAsync = useAsync(exportAbnormalPriceProducts)
    const [toast, setToast] = useState({
        show: false,
        message: '',
        variant: 'info' as 'success' | 'danger' | 'warning' | 'info',
    });
    const accountInfo = useRecoilValue(accountDataState)
    const adminId = useMemo(() => {
        if (accountInfo.loginSession.userLocalType === 'ADMIN') return accountInfo.doctor.mId
    }, [accountInfo])

    const [state, setState] = useState<IState>(initState)
    const tableProduct: any = useRef()
    const page: any = useRef()

    const backToTop = () => {
        if (!tableProduct.current?.scrollTop) return
        tableProduct.current.scrollTop = 0
    }


    useEffect(() => {
        backToTop()
        getAbnormalPriceProductAsync.execute({
            adminId,
            abnormalRatio: state.times,
            area: state.area,
            limit: state.limit,
            offset: state.offset,
        }).then(res => {
            setState(prev => ({ ...prev, listProduct: res.data }))
        })

        getAbnormalPriceProductCountAsync.execute({
            adminId,
            abnormalRatio: state.times,
            area: state.area,
        }).then(res => {
            setState(prev => ({ ...prev, total: res.data.total }))
        })
    }, [state?.times, state?.area, state?.offset, state?.limit, adminId])


    const showToast = (message: string, variant: typeof toast.variant) => {
        setToast({ show: true, message, variant });
    };

    const exportToCSV = async () => {
        try {
            if (state.listProduct.length === 0) {
                showToast('Không có dữ liệu để xuất!', 'warning');
                return;
            }

            setState(prev => ({ ...prev, exporting: true }));

            const res = await exportAbnormalPriceProductsAsync.execute({
                adminId,
                abnormalRatio: state.times,
                area: state.area,
            });

            if (res.waiting) {
                showToast(res.message, 'info');
            } else if (!res.success) {
                showToast(res.message, 'danger');
            } else {
                showToast('Xuất dữ liệu thành công!', 'success');
            }
        } catch (error) {
            console.error('Export error:', error);
            showToast('Đã xảy ra lỗi khi xuất dữ liệu. Vui lòng thử lại sau.', 'danger');
        } finally {
            setState(prev => ({ ...prev, exporting: false }));
        }
    };

    return <>
        <div id="main" style={{
            width: "100%",
            height: '100vh',
            marginTop: '1rem',
            minHeight: '-webkit-fill-available',
        }}
        >
            <MyToast
                show={toast.show}
                message={toast.message}
                variant={toast.variant}
                onClose={() => setToast(prev => ({ ...prev, show: false }))}
                delay={5000}
            />

            {
                <>
                    <div className="d-flex align-items-center justify-content-end my-3">
                        <button className="btn d-flex justify-content-center align-items-center"
                            style={{
                                color: '#ff812c',
                                width: '100%',
                            }}
                            onClick={exportToCSV}
                            disabled={state.exporting}
                            title={state.exporting ? 'Đang xuất dữ liệu...' : 'Xuất file dữ liệu'}
                        >
                            {state.exporting ? 'Đang xuất dữ liệu...' : 'Xuất file dữ liệu'}
                            {state.exporting && (
                                <div className="loader ml-3"></div>
                            )}
                        </button>
                    </div>
                    <h3 className="d-flex py-3 justify-content-center text-center" style={{ fontSize: 25 }}>
                        Sản phẩm có giá bất thường
                    </h3>

                    <div className="d-flex">
                        <div className="w-50 mr-3 d-flex" >
                            <Form.Label className='m-0 mr-1 d-flex justify-content-center align-items-center'>
                                <b style={{ whiteSpace: 'nowrap' }}>Tỉ lệ</b>
                            </Form.Label>
                            <Form.Control onChange={(e) => {
                                const value = e.target.value as ITimes
                                setState(prev => ({ ...prev, times: value }))
                            }} name='filter' as="select" value={state.times} custom>
                                <option value='2'>2</option>
                                <option value='5'>5</option>
                                <option value='10'>10</option>
                                <option value='15'>15</option>
                                <option value='20'>20</option>
                            </Form.Control>
                        </div>
                        <div className="w-50 d-flex align-items-center">
                            <Form.Label className='m-0 mr-1 d-flex justify-content-center align-items-center'>
                                <b style={{ whiteSpace: 'nowrap' }}>Khu vực</b>
                            </Form.Label>
                            <Form.Control onChange={(e) => {
                                const value = e.target.value as IArea
                                setState(prev => ({ ...prev, area: value }))
                            }} name='filter' as="select" value={state.area} custom>
                                <option value=''>Tất cả</option>
                                <option value='mien_nam'>Miền Nam</option>
                                <option value='mien_trung'>Miền Trung</option>
                                <option value='mien_bac'>Miền Bắc</option>
                            </Form.Control>
                        </div>
                    </div>
                    {
                        state.listProduct.length === 0 &&
                        <div className="d-flex py-3 justify-content-center align-items-center">
                            <p className="m-0">Không tìm thấy sản phẩm nào</p>
                        </div>
                    }

                    <div className="row mt-2"></div>

                    {
                        state.listProduct.length !== 0 &&
                        <>
                            <div ref={tableProduct} className="table-products" style={{ position: "relative", maxHeight: 'unset' }}>
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>Tên</th>
                                            <th style={{ width: 40 }}>ĐV</th>
                                            <th style={{ width: 60 }}>Thấp nhất</th>
                                            <th style={{ width: 60 }}>NT giá thấp nhất</th>
                                            <th style={{ width: 60 }}>ĐC NT giá thấp nhất</th>
                                            <th style={{ width: 60 }}>Trạng thái NT giá thấp nhất</th>
                                            <th style={{ width: 60 }}>Cao nhất</th>
                                            <th style={{ width: 60 }}>NT giá cao nhất</th>
                                            <th style={{ width: 60 }}>ĐC NT giá cao nhất</th>
                                            <th style={{ width: 60 }}>Trạng thái NT giá cao nhất</th>
                                            <th style={{ width: 60 }}>Trung Bình</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            state.listProduct?.map((product: any) => {
                                                return <tr key={product.productStat?.m_id} onClick={() => {
                                                    history.push(`/product-detail-dashboard?tab=price&productId=${product.productEs?.id}&packageId=${product.productStat.m_package_id}`)
                                                }}>
                                                    <td >{product?.productEs?.name}</td>
                                                    <td style={{ width: 40 }}>{
                                                        product.productEs?.dong_goi.map((dong_goi: any) => {
                                                            if (dong_goi.id == product.productStat.m_package_id) return dong_goi.loai_dong_goi.name
                                                        })
                                                    }</td>
                                                    <td className="price" style={{ width: 60 }}>
                                                        {formatPrice(product.productStat?.m_min_price)}
                                                    </td>
                                                    <td style={{ width: 60 }}>
                                                        {formatPrice(product.productStat?.m_min_price_phar_name)}
                                                    </td>
                                                    <td style={{ minWidth: 120 }}>
                                                        {formatPrice(product.productStat?.m_min_price_phar_address)}
                                                    </td>
                                                    <td style={{ minWidth: 120 }}>
                                                        {formatPrice(product.productStat?.m_min_price_phar_status)}
                                                    </td>
                                                    <td className={`price`} style={{ width: 60 }}>
                                                        {formatPrice(product.productStat?.m_max_price)}
                                                    </td>
                                                    <td style={{ width: 60 }}>
                                                        {formatPrice(product.productStat?.m_max_price_phar_name)}
                                                    </td>
                                                    <td style={{ minWidth: 120 }}>
                                                        {formatPrice(product.productStat?.m_max_price_phar_address)}
                                                    </td>
                                                    <td style={{ minWidth: 120 }}>
                                                        {formatPrice(product.productStat?.m_max_price_phar_status)}
                                                    </td>
                                                    <td className={`price`} style={{ width: 60 }}>
                                                        {formatPrice(product.productStat?.m_avg_price)}
                                                    </td>
                                                </tr>
                                            })
                                        }

                                    </tbody>
                                </table>
                                {
                                    getAbnormalPriceProductAsync.status == "loading" &&
                                    state.exporting === false &&
                                    <div className="wrap-loading">
                                        <Loading />
                                    </div>
                                }
                            </div>
                            <div className="d-flex align-items-center justify-content-start my-3 px-3">
                                <div className="pagination mt-3">
                                    {
                                        state.total &&
                                        <ReactPaginate
                                            pageClassName='page-item'
                                            breakLabel="..."
                                            onPageChange={(page: any) => {
                                                setState(prev => ({ ...prev, offset: state.limit * page.selected }))
                                            }}
                                            pageCount={Math.ceil(state.total / state.limit)}
                                            pageRangeDisplayed={1}
                                            marginPagesDisplayed={1}
                                            previousLabel={<b className="pagination-navigator">{'<'}</b>}
                                            nextLabel={<b className="pagination-navigator"> {'>'} </b>}
                                            forcePage={(state.offset) / state.limit}
                                        />
                                    }
                                </div>
                                <Form.Control
                                    className="select-page-limit"
                                    onChange={(e) => {
                                        const value = e.target.value
                                        setState(prev => ({
                                            ...prev,
                                            limit: +value,
                                        }))
                                    }
                                    }
                                    name='limit'
                                    as="select"
                                    value={state.limit}
                                    custom
                                >
                                    <option value="5">5</option>
                                    <option value='10'>10</option>
                                    <option value='20'>20</option>
                                    <option value='50'>50</option>
                                    <option value='100'>100</option>
                                </Form.Control>
                            </div>
                            <div className="d-flex align-items-center justify-content-end mb-4">
                                <div className="d-flex align-items-center justify-content-end mr-3"
                                    style={{ width: '60%' }}
                                >
                                    <b>Tổng số {state.total} sản phẩm</b>
                                </div>
                                <div className="d-flex align-items-center mr-3 justify-content-end"
                                    style={{ width: '40%' }}>
                                    <Form.Control type="number" className="mr-2" placeholder="Đến trang"
                                        ref={page}
                                        min={1}
                                        style={{ width: '68%', height: '30px' }} />
                                    <Form.Control
                                        as="button"
                                        onClick={() => {
                                            if (page.current.value > 0 && state.total && page.current.value <= Math.ceil(state.total / state.limit)) {
                                                setState(prev => ({ ...prev, offset: state.limit * (page.current.value - 1) }))
                                            }
                                        }}
                                        style={{ width: '40px', height: '30px', color: '#fff', backgroundColor: '#36cd7a', border: 'none' }}
                                    >Đi</Form.Control>
                                </div>
                            </div>
                        </>
                    }
                </>
            }
        </div>
    </>
})

export default AbnormalPriceProduct;